import React, { Component, Fragment } from 'react';
import {
  Spinner,
  Button
} from 'reactstrap';
import FeatherIcon from "feather-icons-react";
import { Redirect } from "react-router-dom";
import apiResponse from '../../../../../services/apiResponse';
import PenialianBloc from "../Blocs/PenilaianBloc";

// Static legend of predikat categories shown under the employee header
const PREDIKAT_CATEGORIES = [
  { id: 'sangat-kurang', label: 'Sangat Kurang', color: 'danger' },
  { id: 'kurang', label: 'Kurang', color: 'warning text-dark' },
  { id: 'butuh-perbaikan', label: 'Cukup', color: 'warning text-dark' },
  { id: 'baik', label: 'Baik', color: 'info text-dark' },
  { id: 'sangat-baik', label: 'Sangat Baik', color: 'success' },
];

// Maps a predikatId to a Bootstrap badge class
const getPredikatColor = (predikatId) => {
  const found = PREDIKAT_CATEGORIES.find((c) => c.id === predikatId);
  return found ? found.color : 'secondary';
};

// Maps an evaluator's submission status to a Bootstrap badge class
const getStatusColor = (status) => {
  switch (status) {
    case 'Submitted':
      return 'success';

    case 'Draft':
      return 'secondary';

    default:
      return 'light text-dark border';
  }
};

// Convert value to number and round it
const roundValue = (value) => {
  return Math.round(parseFloat(value) || 0);
};


class DetailPegawaiComponent extends Component {

  penialianBloc = new PenialianBloc();

  constructor(props) {
    super(props);

    this.state = {
      redirectBack: false,
      member: {},
      loadingContent: true,
      detailData: {},
      loading: false,
    };

    this.handleBack = this.handleBack.bind(this);
  }

  getStatusPredikat = (num) => {
    if(parseInt(num) === 5){
      return (
        <span
          className={`text-white badge rounded-pill bg-${getPredikatColor('sangat-baik')}`}
        >
          {'Sangat Baik'}
        </span>
       )
    }if(parseInt(num) === 4){
      return (
        <span
          className={`text-white badge rounded-pill bg-${getPredikatColor('baik')}`}
        >
          {'Baik'}
        </span>
       )
    }if(parseInt(num) === 3){
      return (
        <span
          className={`text-white badge rounded-pill bg-${getPredikatColor('cukup')}`}
        >
          {'Cukup'}
        </span>
       )
    }if(parseInt(num) === 2){
      return (
        <span
          className={`text-white badge rounded-pill bg-${getPredikatColor('kurang')}`}
        >
          {'Kurang'}
        </span>
       )
    }else{
       return (
        <span
          className={`text-white badge rounded-pill bg-${getPredikatColor('sangat-kurang')}`}
        >
          {'Sangat Kurang'}
        </span>
       )
    }
  }


  renderEvaluatorGroup(group, groupIndex) {
    return (
      <div
        className="mb-4"
        key={group.groupId || groupIndex}
      >

        {/* Group Header */}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">

          <h6 className="mb-0 fw-semibold">
            {groupIndex + 1}. {group.groupTitle}
          </h6>

          <span className="badge rounded-pill bg-primary px-3 py-2">
            Bobot Peran: {roundValue(group.bobotPercent)}%
          </span>

        </div>


        {/* Evaluator Table */}
        <div className="table-responsive">

          <table className="table table-bordered table-hover align-middle mb-2">

            <thead className="table-light">
              <tr>
                <th style={{ width: 40 }}>No</th>
                <th>Penilai (Evaluator)</th>
                <th>Jabatan Penilai</th>
                <th className="text-center">
                  Skor Total Jawaban
                </th>
                <th className="text-center">
                  Skor Maksimal
                </th>
                <th className="text-center">
                  Skor Akhir (Skala 100)
                </th>
                <th className="text-center">
                  Status
                </th>
              </tr>
            </thead>

            <tbody>

              {group.evaluators.map((ev, index) => (

                <tr key={index}>

                  <td>
                    {index + 1}
                  </td>

                  <td>
                    {ev.nama}
                  </td>

                  <td>
                    {ev.jabatan}
                  </td>

                  <td className="text-center">
                    {roundValue(ev?.total_result)}
                  </td>

                  <td className="text-center">
                    {roundValue(ev?.total_max)}
                  </td>

                  <td className="text-center">
                    {roundValue(ev?.total_final)}
                  </td>

                  <td className="text-center">

                    {ev.status !== '-' && ev.status !== null ? (

                      <span
                        className={`badge rounded-pill bg-${getStatusColor(ev.status)}`}
                      >
                        {ev?.status_text}
                      </span>

                    ) : (

                      <span className="badge rounded-pill bg-light text-dark border">
                      </span>

                    )}

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>


        {/* Group Average */}
        <div className="d-flex justify-content-end align-items-center">

          <span className="text-muted me-2">

            {group.groupId === 'atasan' && (
              <>Rata-Rata Kelompok Atasan : </>
            )}

            {group.groupId === 'bawahan' && (
              <>Rata-Rata Kelompok Bawahan : </>
            )}

            {group.groupId === 'sejawat' && (
              <>Rata-Rata Kelompok Rekan/Sejawat : </>
            )}

          </span>

          <span className="badge rounded-pill bg-primary px-3 py-2 fs-6">
            {roundValue(group?.averageScore)}
          </span>

        </div>

      </div>
    );
  }


  renderRoleWeightingTable(detailData) {

    const {
      roleWeightings = [],
      totalWeighting = {}
    } = detailData;

    return (

      <div className="mb-4">

        <h6 className="fw-semibold mb-2">
          Pembobotan Peran (Nilai Akhir Keseluruhan / Overall)
        </h6>


        <div className="table-responsive">

          <table className="table table-bordered align-middle mb-2">

            <thead className="table-light">

              <tr>

                <th>
                  Peran
                </th>

                <th className="text-center">
                  Bobot (%)
                </th>

                <th className="text-center">
                  Nilai (Rata-Rata Kelompok)
                </th>

                <th className="text-center">
                  Nilai Akhir (Setelah Bobot)
                </th>

              </tr>

            </thead>


            <tbody>

              {roleWeightings.map((row, idx) => (

                <tr key={idx}>

                  <td>
                    {row.peran}
                  </td>

                  <td className="text-center">
                    {roundValue(row?.bobot)}
                  </td>

                  <td className="text-center">
                    {roundValue(row?.total_avg)}
                  </td>

                  <td className="text-center">
                    {roundValue(row?.total_weight)}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>


        {/* Overall Summary */}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

          <div>

            <span className="text-muted me-2">
              Predikat Overall:
            </span>

            <span
              className={`text-white badge rounded-pill bg-${getPredikatColor(
                totalWeighting.predikatId
              )}`}
            >
              {totalWeighting.predikat}
            </span>

          </div>


          <div className="d-flex align-items-center">

            <span className="text-muted me-2">
              Jumlah Nilai Overall:
            </span>

            <span className="badge rounded-pill bg-primary px-3 py-2 fs-6 text-white">
              {roundValue(totalWeighting.nilai_akhirnya)}
            </span>

          </div>

        </div>

      </div>

    );
  }


  ucfirst = (str) => {

    if (!str) {
      return '';
    }

    return str.charAt(0).toUpperCase() + str.slice(1);
  };


  renderBerakhlakTable(detailData) {

    const {
      berakhlak_weightings = [],
      berakhlak_summary = {}
    } = detailData;


    const relations = this.state.detailData?.relations || [];


    return (

      <div className="mb-2">

        <h6 className="fw-semibold mb-2">
          Rincian &amp; Rekapitulasi Pembobotan Core Values BerAKHLAK
        </h6>


        <div className="table-responsive">

          <table className="table table-bordered mb-2">

            <thead>

              <tr>

                <th>
                  Core Value / Kompetensi BerAKHLAK
                </th>


                {relations.map((xx, i) => (

                  <th
                    className="text-center"
                    key={i}
                  >
                    Rata-rata {this.ucfirst(xx?.key)}
                  </th>

                ))}

                <th className="text-center">
                  Total Nilai
                </th>


                <th className="text-center">
                  Hasil Terbobot ({this.state.detailData?.bobot_berahlak}%)
                </th>

                {/* <th className="text-center">
                  Predikat
                </th> */}

              </tr>

            </thead>


            <tbody>

              {berakhlak_weightings.map((row, idx) => (

                <tr key={idx}>

                  <td>

                    <div className="fw-semibold">
                      {row.core_value}
                    </div>

                    <div className="text-muted small">
                      {row.deskripsi}
                    </div>

                  </td>


                  {relations.map((xx, i) => (

                    <td
                      className="text-center"
                      key={i}
                    >
                      <div className='d-block mb-1'>
                        {roundValue(row?.[xx.index])}
                      </div>
                      <span className='d-block'>
                          {this.getStatusPredikat(roundValue(row?.[xx.index]))}
                      </span>
                    </td>

                  ))}

                  <td className="text-center">
                    <div className='mt-2'>
                      {roundValue(row?.total_nilai)}
                    </div>
                  </td>

                  <td className="text-center">
                   
                     <div className='d-block mb-1'>
                         {roundValue(row?.hasil_terbobot)}
                      </div>
                      <span className='d-block'>
                          <span className="badge rounded-pill bg-light text-dark border">
                            {row.predikat}
                          </span>
                      </span>
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>


        {/* BerAKHLAK Summary */}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

          <span className="text-muted">

            Rata-Rata BerAKHLAK per Kelompok Penilai:
            {' '}
            {berakhlak_summary.keterangan}

          </span>


          <div className="d-flex align-items-center">

            <span className="text-muted me-2">
              NILAI FINAL BERAKHLAK:
            </span>

            <span className="badge rounded-pill bg-primary px-3 py-2 fs-6 me-2">
              {roundValue(berakhlak_summary.nilai_final)}
            </span>


            <span
              className={`badge rounded-pill bg-${getPredikatColor(
                berakhlak_summary.predikat_final_id
              )}`}
            >
              {berakhlak_summary.predikat_final}
            </span>

          </div>

        </div>

      </div>

    );
  }


  handleBack(e) {

    this.setState({
      redirectBack: true
    });

  }


  loadData = async () => {

    const queryParams = new URLSearchParams(
      window.location.search
    );

    const uuid = queryParams.get('uuid');

    await this.penialianBloc.fetchRecapComponent({
      uuid: uuid
    });

  };


  componentDidMount() {

    this.loadData();


    this.penialianBloc.recapPeriodComponentChannel.subscribe(
      (result) => {

        switch (result.status) {

          case apiResponse.INITIAL:

            this.setState({
              loadingContent: false
            });

            break;


          case apiResponse.LOADING:

            this.setState({
              loadingContent: true
            });

            break;


          case apiResponse.COMPLETED:

            const response = result.data.response;

            this.setState({

              loadingContent: false,

              member: response.member,

              detailData: response.detail

            });

            break;


          case apiResponse.ERROR:

            this.setState({
              loadingContent: false
            });

            break;


          default:
            break;

        }

      }
    );

  }


  componentWillUnmount() {

    this.penialianBloc.recapPeriodComponentChannel.unsubscribe();

  }


  render() {

    const {
      detailData,
      loading
    } = this.state;


    if (!detailData) {
      return null;
    }


    const {
      employee = {},
      scores = {},
      totalMapping = 0,
      evaluatorGroups = []
    } = detailData;


    return (

      <Fragment>


        {/* Loading */}
        {this.state.loadingContent ? (

          <div className="card">

            <div className="card-body p-5 text-center">

              <Spinner
                size="sm"
                className="me-1"
              />

              Memuat Data...

            </div>

          </div>

        ) : (

          <Fragment>

            <div className="container-fluid py-4">


              {/* Page Title */}
              <div className="card mb-3">

                <div className="card-body p-4">

                  <div className="clearfix">


                    <div className="float-start">

                      <h5 className="card-title fw-bold mb-1">
                        Detail Breakdown Umpan Balik 360°
                      </h5>


                      <p className="card-subtitle text-muted mb-0">

                        Rincian skor per individu penilai dari tabel
                        kalkulasi pembobotan akhir untuk{' '}

                        {employee.nama}

                      </p>

                    </div>


                    <div className="float-end">

                      <Button
                        type="button"
                        onClick={this.handleBack}
                        className="pn-btn-outline btn-danger"
                      >

                        <FeatherIcon
                          icon="arrow-left"
                          size="16"
                        />

                        <span className="ms-2">
                          Kembali
                        </span>

                      </Button>

                    </div>

                  </div>

                </div>

              </div>


              {/* Main Card */}
              <div
                className="card border-0 shadow-sm"
                style={{ borderRadius: 14 }}
              >

                <div className="card-body p-4">

                  {loading ? (

                    <div className="text-center py-5">

                      <div
                        className="spinner-border text-primary mb-2"
                        role="status"
                      >

                        <span className="visually-hidden">
                          Loading...
                        </span>

                      </div>

                      <div className="text-muted">
                        Memuat data...
                      </div>

                    </div>

                  ) : (

                    <Fragment>


                      {/* Employee Header */}
                      <div className="d-flex align-items-start justify-content-between flex-wrap gap-3 mb-3">

                        <div>

                          <h5 className="mb-1">

                            {employee.nama}{' '}

                            <span className="badge rounded-pill bg-dark ms-1">
                              {employee.level}
                            </span>

                          </h5>


                          <div className="text-muted small">
                            NIP: {employee.nip}
                          </div>


                          <div className="text-muted small">
                            {employee.jabatan}
                            {' - '}
                            {employee.unitKerja}
                          </div>

                        </div>


                        {/* Score Cards */}
                        <div className="d-flex gap-2">


                          <div
                            className="text-center border rounded p-2"
                            style={{ minWidth: 130 }}
                          >

                            <div className="small text-muted">
                              Nilai Keseluruhan
                            </div>


                            <div className="fw-bold fs-5">
                              {roundValue(scores.nilaiKeseluruhan)}
                            </div>


                            <span
                              className={`text-white badge rounded-pill bg-${getPredikatColor(
                                scores.predikatKeseluruhanId
                              )}`}
                            >
                              {scores.predikatKeseluruhan}
                            </span>

                          </div>


                          <div
                            className="text-center border rounded p-2"
                            style={{ minWidth: 130 }}
                          >

                            <div className="small text-muted">
                              BerAKHLAK 360
                            </div>


                            <div className="fw-bold fs-5">
                              {roundValue(scores.berAkhlak360)}
                            </div>


                            <span
                              className={`text-white badge rounded-pill bg-${getPredikatColor(
                                scores.predikatBerAkhlakId
                              )}`}
                            >
                              {scores.predikatBerAkhlak}
                            </span>

                          </div>


                        </div>

                      </div>


                      {/* Predikat Legend */}
                      <div className="mb-4">

                        <span className="text-muted small me-2">
                          Indikator Nilai:
                        </span>


                        {PREDIKAT_CATEGORIES.map((cat) => (

                          <span
                            className={`text-white badge rounded-pill bg-${cat.color} me-1`}
                            key={cat.id}
                          >
                            {cat.label}
                          </span>

                        ))}

                      </div>


                      {/* Evaluator Groups */}
                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">

                        <h6 className="mb-0 fw-semibold">
                          Rincian Poin &amp; Skor Per Penilai Individu
                        </h6>


                        <span className="badge rounded-pill bg-light text-dark border">

                          Total Mapping:
                          {' '}
                          {totalMapping}
                          {' '}
                          Penilai

                        </span>

                      </div>


                      {evaluatorGroups.map(
                        (group, idx) =>
                          this.renderEvaluatorGroup(
                            group,
                            idx
                          )
                      )}


                      <hr />


                      {/* Role Weighting */}
                      {this.renderRoleWeightingTable(
                        detailData
                      )}


                      <hr />


                      {/* BerAKHLAK Weighting */}
                      {this.renderBerakhlakTable(
                        detailData
                      )}

                    </Fragment>

                  )}

                </div>

              </div>

            </div>

          </Fragment>

        )}


        {/* Redirect Back */}
        {this.state.redirectBack ? (

          <Redirect
            to={`/kepegawaian/rekap360.html?section=detail&uuid=${this.state.member?.ms360_team_period_uuid}&team_uuid=${this.state.member?.ms360_team_uuid}`}
          />

        ) : null}


      </Fragment>

    );

  }

}


export default DetailPegawaiComponent;